module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-tab"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed  tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#details1"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRES6EUC3']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in tab-detail",
    attrs: {
      "id": "details1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "clearfix detail-block"
  }, [_c('div', {
    staticClass: "detail-field-float detail-field-left border-color-skin clearfix"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES6EUC3']['200']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "coddesc_codinput",
      "name": "coddesc_codinput"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.codinput) + " - " + _vm._s(_vm.detail.tab1.desc_codinput))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES6EUC3']['10']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "coddesc_codempid",
      "name": "coddesc_codempid"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.codempid) + " - " + _vm._s(_vm.detail.tab1.desc_codempid))])])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-field-float detail-field-right border-color-skin clearfix"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES6EUC3']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "dtereq",
      "name": "dtereq"
    }
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail.tab1.dtereq)))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES6EUC3']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "dtework",
      "name": "dtework"
    }
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail.tab1.dtework)))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-block"
  }, [_c('div', {
    staticClass: "detail-block-float detail-block-left"
  }, [_c('div', {
    staticClass: "detail-header"
  }, [_vm._v(_vm._s(_vm.labels['HRES6EUC3']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES6EUC3']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "typwrko",
      "name": "typwrko"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.typwrko))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES6EUC3']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "typwrkn",
      "name": "typwrkn"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.typwrkn))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES6EUC3']['70']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "coddesc_codshifto",
      "name": "coddesc_codshifto"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.codshifto) + " - " + _vm._s(_vm.detail.tab1.desc_codshifto))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES6EUC3']['80']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "coddesc_codshiftn",
      "name": "coddesc_codshiftn"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.codshiftn) + " - " + _vm._s(_vm.detail.tab1.desc_codshiftn))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES6EUC3']['90']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "timwoe_btw",
      "name": "timwoe_btw"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.timstrtwoe) + " - " + _vm._s(_vm.detail.tab1.timendwoe))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES6EUC3']['100']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "timwe_btw",
      "name": "timwe_btw"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.timstrtwe) + " - " + _vm._s(_vm.detail.tab1.timendwe))])])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-block-float detail-block-right"
  }, [_c('div', {
    staticClass: "detail-header"
  }, [_vm._v(_vm._s(_vm.labels['HRES6EUC3']['110']))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES6EUC3']['120']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "typwrkro",
      "name": "typwrkro"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.typwrkro))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES6EUC3']['130']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "typwrkrn",
      "name": "typwrkrn"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.typwrkrn))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES6EUC3']['140']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "coddesc_codshifro",
      "name": "coddesc_codshifro"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.codshifro) + " - " + _vm._s(_vm.detail.tab1.desc_codshifro))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES6EUC3']['150']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "coddesc_codshifrn",
      "name": "coddesc_codshifrn"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.codshifrn) + " - " + _vm._s(_vm.detail.tab1.desc_codshifrn))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES6EUC3']['160']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "timwor_btw",
      "name": "timwor_btw"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.timstrtwor) + " - " + _vm._s(_vm.detail.tab1.timendwor))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES6EUC3']['170']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "timwr_btw",
      "name": "timwr_btw"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.timstrtwr) + " - " + _vm._s(_vm.detail.tab1.timendwr))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-field-float detail-field-left border-color-skin clearfix"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES6EUC3']['180']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-100 txtarea-width response-full-width",
    attrs: {
      "id": "remark",
      "name": "remark"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.remark))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#details2"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRES6EUC4']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "details2"
    }
  }, [(_vm.detail.tab1.codempid) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('hrms-calendar-work-time', {
    attrs: {
      "codempid": _vm.detail.tab1.codempid
    }
  })], 1) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.toggle('index')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left"
  }), _vm._v(_vm._s(_vm.labelsButton['back']))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-36c28c49!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres6eu/detail.vue
// module id = 3680
// module chunks = 1